<template>
    <NavigationDropdown
        :closeContentClick="false"
        ref="dropDownLoginComponent"
        key="login"
        :isExpander="true"
        dropDownElementClass="mm-navigation__menu-link mm-navigation__menu-link--expander">
        <template slot="link">
            <div class="mm-navigation__menu-list-item-container">
                <i class="icon icon-dots mm-navigation__menu-list-item-icon"></i>
                <span
                class="mm-navigation__menu-list-item-label"
                >Prepinac</span>
            </div>
            <div class="mm-navigation__expander-btn">
                <span>{{locale}}</span>
                <span>
                <i class="icon icon-down"></i>
                </span>
            </div>
        </template>
        <div style="min-width: 200px;">
            <div
                class="dropdown__item dropdown__item--dark dropdown__item--extra-big"
                v-for="lng in nonActiveLocales"
                :key="lng.locale">
                <a v-if="isSingleLanguagePage && lng.locale !== locale"
                    class="dropdown-item truncate"
                    target="_self"
                    :href="$router.resolve(
                        localeRoute({name: 'index'}, lng.locale)).href">
                        <img :src="lng.img" class="dropdown-item__flag" />

                        {{lng.localeLabel}}
                        <span class="dropdown-item__pipe">|</span>
                        {{lng.name}}
                </a>
                <a v-else-if="!isSingleLanguagePage && lng.locale !== locale"
                    class="dropdown-item truncate"
                    target="_self"
                    :href="$router.resolve(
                    localeRoute({
                            name: getDefaultRouteName,
                            params: getRouteParams,
                            query: getRouteQueryParams
                        }, lng.locale
                    )).href">
                        <img :src="lng.img" class="dropdown-item__flag" />
                        {{lng.localeLabel}}
                        <span class="dropdown-item__pipe">|</span>
                        {{lng.name}}
                </a>
            </div>
        </div>
    </NavigationDropdown>
</template>

<script>
import NavigationDropdown from './NavigationDropdown';

export default {
    components: {
        NavigationDropdown
    },
    methods: {
        getLanguageSwitcherConf(lng) {
            const languageSwitcher = this.$store.state.languageSwitcher;
            return languageSwitcher && languageSwitcher[lng];
        }
    },
    computed: {
        nonActiveLocales() {
            const locales = this.$store.state.locales;
            const filtered = locales.filter(lng => {
                return (
                    (this.isSingleLanguagePage && lng !== this.locale) ||
                    (!this.isSingleLanguagePage && lng !== this.locale)
                );
            });

            const languages = filtered.map(item => {
                const languageSwitcherConf = this.getLanguageSwitcherConf(item);
                return {
                    locale: item,
                    localeLabel: item.toUpperCase(),
                    name: languageSwitcherConf && languageSwitcherConf.name,
                    img: languageSwitcherConf && languageSwitcherConf.img
                }
            });

            return languages;
        },
        locale() {
            return this.$i18n.locale;
        },
        isSingleLanguagePage() {
            return (
                this.$store.state.noMultilanguagePages &&
                this.$store.state.noMultilanguagePages[this.getDefaultRouteName]
            );
        },
        getDefaultRouteName() {
            return this.$route.name && this.$route.name.split("__")[0];
        },
        getRouteParams() {
            return this.$route.params;
        },
        getRouteQueryParams() {
            return this.$route.query;
        }
    }
};
</script>
